import { resolveWallRewardClearSpeed } from "./wallRewardClearSpeed";
import type { WallDefinition } from "./wallDefinitions";
import { STEP_WALL_BALANCE_PROFILE } from "./wallBalanceProfiles";
import {
  DEFAULT_WALL_REWARD_CAP_LEVEL,
  type WallRewardCapLevel,
} from "./wallRewardCap";

export const STEP_WALL_DEFINITION: WallDefinition = {
  id: "step-wall",
  firstClearReward: STEP_WALL_BALANCE_PROFILE.firstClearReward,
};

// Step Wall — even-numbered Hov Cells (player-facing H2/H4/H6/H8) cannot be
// unlocked. Mapped to 0-based cell indices for internal use.
export const STEP_WALL_BLOCKED_CELL_INDICES: readonly number[] =
  STEP_WALL_BALANCE_PROFILE.challenge.blockedCellIndices;

export const STEP_WALL_REWARD_BASE_MULTIPLIER =
  STEP_WALL_BALANCE_PROFILE.reward.baseMultiplier;
export const STEP_WALL_REWARD_TARGET_CLEAR_MS =
  STEP_WALL_BALANCE_PROFILE.reward.targetClearMs;
export const STEP_WALL_REWARD_ACCELERATION =
  STEP_WALL_BALANCE_PROFILE.reward.acceleration;
export const STEP_WALL_REWARD_EXPONENT =
  STEP_WALL_BALANCE_PROFILE.reward.exponent;
export const STEP_WALL_REWARD_BASE_CAP_MULTIPLIER =
  STEP_WALL_BALANCE_PROFILE.reward.caps.base;
export const STEP_WALL_REWARD_RELAXED_CAP_MULTIPLIER =
  STEP_WALL_BALANCE_PROFILE.reward.caps.relaxed;

export function resolveStepWallRewardEffectiveMaxMultiplier(
  capLevel: WallRewardCapLevel = DEFAULT_WALL_REWARD_CAP_LEVEL,
): number {
  return capLevel === "relaxed"
    ? STEP_WALL_REWARD_RELAXED_CAP_MULTIPLIER
    : STEP_WALL_REWARD_BASE_CAP_MULTIPLIER;
}

export function resolveStepWallRewardMultiplier(
  bestClearMs: number | null,
  effectiveMaxMultiplier: number = resolveStepWallRewardEffectiveMaxMultiplier(),
): number {
  if (bestClearMs === null) return 1;
  if (!Number.isFinite(bestClearMs) || bestClearMs <= 0) {
    return STEP_WALL_REWARD_BASE_MULTIPLIER;
  }

  const ratio = resolveWallRewardClearSpeed(
    bestClearMs,
    STEP_WALL_REWARD_TARGET_CLEAR_MS,
    STEP_WALL_BALANCE_PROFILE.reward.softcapClearMs,
  );
  const acceleratedRatio = Math.max(0, ratio - 1);

  return Math.min(
    effectiveMaxMultiplier,
    Math.max(
      STEP_WALL_REWARD_BASE_MULTIPLIER,
      STEP_WALL_REWARD_BASE_MULTIPLIER +
        STEP_WALL_REWARD_ACCELERATION *
          Math.pow(acceleratedRatio, STEP_WALL_REWARD_EXPONENT),
    ),
  );
}
